import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { LoginLogoutActionTypes } from '../../../auth/user-auth/store/actions/login-logout.action';
import { normalizeHttpError, withdrawOn } from '../../../util';
import { AssortmentConnector } from '../../connectors/assortment.connector';
import { UserActions } from '../actions';

@Injectable()
export class AssortmentEffects {
  private contextChange$ = this.actions$.pipe(ofType(LoginLogoutActionTypes.Logout));

  loadConsignmentStockArticles$: Observable<
    UserActions.LoadConsignmentStockArticlesSuccess | UserActions.LoadConsignmentStockArticlesFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.AssortmentActionTypes.LoadConsignmentStockArticles),
      map((action: UserActions.LoadConsignmentStockArticles) => action.payload),
      switchMap((payload) =>
        this.connector.getConsignmentStockArticles(payload).pipe(
          map((articleRefs) => new UserActions.LoadConsignmentStockArticlesSuccess(articleRefs)),
          catchError((error) => of(new UserActions.LoadConsignmentStockArticlesFail(normalizeHttpError(error))))
        )
      ),
      withdrawOn(this.contextChange$)
    )
  );

  loadConsignmentStockInfo$: Observable<
    UserActions.LoadConsignmentStockArticleStockInfoSuccess | UserActions.LoadConsignmentStockArticleStockInfoFail
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.AssortmentActionTypes.LoadConsignmentStockArticleStockInfo),
      map((action: UserActions.LoadConsignmentStockArticleStockInfo) => action.payload),
      mergeMap((payload) =>
        this.connector.getConsignmentStockArticleStockInformation(payload.userId, payload.articleRef).pipe(
          map(
            (stockInformation) =>
              new UserActions.LoadConsignmentStockArticleStockInfoSuccess(payload.articleRef, stockInformation)
          ),
          catchError((error) =>
            of(new UserActions.LoadConsignmentStockArticleStockInfoFail(payload.articleRef, normalizeHttpError(error)))
          )
        )
      ),
      withdrawOn(this.contextChange$)
    )
  );

  constructor(private actions$: Actions, private connector: AssortmentConnector) {}
}
